var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import zip from "lodash.zip";
import invariant from "tiny-invariant";
/**
 * Thrown if an account could not be loaded.
 */
export class SolanaAccountLoadError extends Error {
    constructor(originalError, accountId) {
        super(`Error loading account: ${originalError.message}`);
        this.originalError = originalError;
        this.accountId = accountId;
        this.name = "SolanaAccountLoadError";
    }
    get userMessage() {
        return `Error loading account ${this.accountId.toString()}`;
    }
}
export const fetchKeysUsingLoader = (loader, keys, onAccountLoadError) => __awaiter(void 0, void 0, void 0, function* () {
    const keysWithIndex = keys.map((k, i) => [k, i]);
    const keysSpecified = keysWithIndex.filter((args) => !!args[0]);
    const result = yield loader.loadMany(keysSpecified.map((k) => k[0]));
    const nextData = keys.map(() => undefined);
    zip(keysSpecified, result).forEach(([indexInfo, keyResult]) => {
        invariant(indexInfo, "index info missing");
        invariant(keyResult !== undefined, "key result missing");
        const [accountId, nextIndex] = indexInfo;
        if (keyResult instanceof Error) {
            if (onAccountLoadError) {
                const err = new SolanaAccountLoadError(keyResult, accountId);
                onAccountLoadError(err);
            }
            nextData[nextIndex] = null;
            return;
        }
        nextData[nextIndex] = keyResult
            ? {
                accountId,
                accountInfo: keyResult,
            }
            : null;
    });
    return nextData;
});
//# sourceMappingURL=fetchKeysUsingLoader.js.map